import { CenterBox } from "./compnents"
import map from './assets/map.png'

export const ContractUs = () => {
    return <div style={{ position: 'relative', height: '60rem' }}>
        <CenterBox style={{ top: '5rem', alignItems: 'center' }}>
            <div>
                <h2>联系我们</h2>
                <div>
                    <h3>北京总部</h3>
                    <div style={{ marginLeft: '5rem' }}>
                        <div>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：北京市西城区太平街甲6号富力摩根中心E座10层1015室</div>
                        <div>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话：010-63159020</div>
                        <div>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：zongyi@visiontmt.com</div>
                        <div>联&nbsp;&nbsp;系&nbsp;&nbsp;人：宗女士</div>
                        <div>联系电话：18710134878</div>
                    </div>
                    <h3 style={{ marginTop: '2rem' }}>上海分公司</h3>
                    <div style={{ marginLeft: '5rem' }}>
                        <div>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：上海市徐汇宜山路407号徐汇尚光中心金座1301室</div>
                        <div>联&nbsp;&nbsp;系&nbsp;&nbsp;人：秦先生</div>
                        <div>联系电话：13795364908</div>
                    </div>
                </div>
            </div>
            <div style={{ marginLeft: '5rem', marginTop: '8rem' }}>
                <img src={map} alt={'map'} style={{ width: '50rem', height: '30rem' }} />
            </div>
        </CenterBox>
    </div>
}